import {SocialItems } from './../Data'
import './../style/Global.css'
import './../style/Contacts.css';

const Contacts = () => {
  return (
    <div className="contact-container" id='Contacts'>
      <div className="contact-item min-w-355">
        <h2 className='contact-title'>контакты</h2>
        <p className='contact-address'>Среднерогатская, 13, к.1, стр.1</p>
        <a className='phone-link' href="tel:+7 (911) 945-57-57">+7 (911) 945-57-57</a>
        <ul className="social-link-wrapp">
          {SocialItems.map((item, index) => {
            return (
              <li key={index}>
                <a href={item.linkUrl}>
                  <img className="social-icon-contact mr-7" src={item.iconBlack} alt="" />
                </a>
              </li>
            )
          })}
        </ul>        
      </div>
      <div className="contact-item contact-item-map">
      {/* <iframe title="myFrame" src="https://www.youtube.com/embed/uXWycyeTeCs"></iframe> */}
      </div>
    </div>
  )
} 

export default Contacts